<template>
  <div class="content">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="招商概括" name="invest">
        <el-form
          label-position="right"
          label-width="150px"
          :model="investForm"
          :rules="rules"
          ref="refForm"
        >
          <el-form-item label="引进项目数量" prop="introduced_projects">
            <el-input
              type="number"
              min="0"
              class="numInput"
              v-model="investForm.introduced_projects"
            ></el-input>
          </el-form-item>
          <el-form-item label="完成率" prop="completion_rate">
            <el-input
              type="number"
              min="0"
              max="100"
              class="numInput"
              v-model="investForm.completion_rate"
              ><template slot="append">%</template></el-input
            >
          </el-form-item>
          <el-form-item label="入驻率" prop="settlement_rate">
            <el-input
              type="number"
              min="0"
              max="100"
              class="numInput"
              v-model="investForm.settlement_rate"
              ><template slot="append">%</template></el-input
            >
          </el-form-item>

          <el-form-item label="写字楼招商总面积" prop="building_area">
            <el-input
              type="number"
              min="0"
              class="numInput"
              v-model="investForm.building_area"
            ></el-input>
          </el-form-item>
          <el-form-item label="写字楼招商完成面积" prop="building_finish_area">
            <el-input
              type="number"
              min="0"
              class="numInput"
              v-model="investForm.building_finish_area"
            ></el-input> </el-form-item
          ><el-form-item label="商业楼招商总面积" prop="building_sale_area">
            <el-input
              type="number"
              min="0"
              class="numInput"
              v-model="investForm.building_sale_area"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="商业楼招商完成面积"
            prop="building_sale_finish_area"
          >
            <el-input
              type="number"
              min="0"
              class="numInput"
              v-model="investForm.building_sale_finish_area"
            ></el-input>
          </el-form-item>

          <!-- <el-form-item label="已转化" prop="converted">
        <el-input
          class="numInput"
          @blur="convertedIup"
          type="number"
          min="0"
          max="100"
          v-model="investForm.converted"
        >
          <template slot="append">%</template></el-input
        >
      </el-form-item>
      <el-form-item label="待转化" prop="to_be_converted">
        <el-input
          class="numInput"
          @blur="beConvertedIup"
          type="number"
          min="0"
          max="100"
          v-model="investForm.to_be_converted"
        >
          <template slot="append">%</template></el-input
        >
      </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="investEdit()">保存</el-button>
            <el-button @click="getInvestList()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="园区营收年度目标" name="target">
        <el-form
          label-position="right"
          label-width="150px"
          :model="targetForm"
          :rules="rules"
          ref="refForm"
        >
          <el-form-item label="目标" prop="target">
            <el-input
              type="number"
              min="0"
              class="numInput"
              v-model="targetForm.target"
            ></el-input>
          </el-form-item>
          <el-form-item label="完成率" prop="finish_rate">
            <el-input
              type="number"
              min="0"
              max="100"
              class="numInput"
              v-model="targetForm.finish_rate"
              ><template slot="append">%</template></el-input
            >
          </el-form-item>
          <el-form-item label="月完成" prop="month_finish">
            <el-input
              type="number"
              min="0"
              class="numInput"
              v-model="targetForm.month_finish"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="targetEdit()">保存</el-button>
            <el-button @click="getTargetList()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="园区营收占比概括" name="revenue">
        <el-form
          v-for="(revenueItem, revenueIndex) in revenueForm"
          :ref="`refForm${revenueIndex}`"
          :key="revenueIndex"
          :model="revenueItem"
          :rules="rules"
          :inline="true"
        >
          <el-form-item label-width="130px" label="行业类型名称：" prop="type">
            <el-input
              v-model="revenueItem.type"
              style="width: 207px; float: left"
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
          <el-form-item
            label-width="120px"
            label="收益占比："
            prop="proportion"
          >
            <el-input
              style="width: 207px; float: left"
              v-model.number="revenueItem.proportion"
              οninput="value=value.replace(/[^0-9]/g,'')"
              ><template slot="append">%</template></el-input
            >
            <i
              v-if="revenueIndex != 0"
              @click="delRevenueType(revenueIndex)"
              style="margin-left: 15px; font-size: 20px"
              class="el-icon-delete"
            ></i>
          </el-form-item>
        </el-form>
        <el-button size="small" type="primary" @click="addRevenue()"
          >添加</el-button
        >
        <el-form style="margin-top: 20px">
          <el-form-item>
            <el-button type="primary" @click="revenueEdit()">保存</el-button>
            <el-button @click="getRevenueList()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="园区税收统计" name="tax">
        <el-form
          style="border: 1px solid #666;
    padding: 10px;margin-bottom: 10px;"
          v-for="(taxItem, taxIndex) in taxForm"
          :ref="`refForm${taxIndex}`"
          :key="taxIndex"
          :model="taxItem"
          :rules="rules"
          :inline="true"
        >
          <el-form-item label-width="100px" label="年份：" prop="year">
            <el-input
              v-model="taxItem.year"
              style="width: 207px; float: left"
              placeholder="请输入年份"
            ></el-input>
          </el-form-item>
          <el-form-item
            label-width="100px"
            label="季度："
            prop="quarter"
          >
            <el-input
              style="width: 207px; float: left"
              v-model.number="taxItem.quarter"
              placeholder="请输入季度"
              ></el-input
            >
            <el-button v-if="taxItem.data.length < 3" style="margin-left: 20px;" size="small" type="text" @click="addData(taxIndex)"
          >添加月份</el-button
        >
          </el-form-item>
          <div v-for="(dataItem,dataIndex) in taxItem.data" :key="dataIndex">
            <el-form-item
            label-width="120px"
            label="月份（数字）："
            prop="quarter"
          >
            <el-input
              style="width: 207px; float: left"
              v-model.number="dataItem.month"
              placeholder="请输入月份（数字）"
              ></el-input
            >
          </el-form-item>
          <el-form-item
            label-width="100px"
            label="数量："
            prop="quarter"
          >
            <el-input
              style="width: 207px; float: left"
              v-model.number="dataItem.nums"
              placeholder="请输入数量"
              ></el-input
            >
          </el-form-item>
          <el-form-item
            label-width="120px"
            label="月份文案(1月)："
            prop="quarter"
          >
            <el-input
              style="width: 207px; float: left"
              v-model="dataItem.month_text"
              placeholder="请输入月份文案(1月)"
              ></el-input
            >
          </el-form-item>
          <i
              v-if="dataIndex != 0"
              @click="delTaxData(taxIndex,dataIndex)"
              style="margin-left: 15px; font-size: 20px"
              class="el-icon-delete"
            ></i>
          </div>
        </el-form>
        <el-button size="small" type="primary" @click="addTax()"
          >添加</el-button
        >
        <el-form style="margin-top: 20px">
          <el-form-item>
            <el-button type="primary" @click="taxEdit()">保存</el-button>
            <el-button @click="getTaxList()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="商业产业类型概括" name="industry">
        <el-form
          v-for="(industryItem, industryIndex) in industryForm"
          :ref="`industryForm${industryIndex}`"
          :key="industryIndex"
          :model="industryItem"
          :rules="rules"
          :inline="true"
        >
          <el-form-item label-width="130px" label="类型名称：" prop="type_name">
            <el-input
              v-model="industryItem.type_name"
              style="width: 207px; float: left"
              placeholder="请输入类型名称"
            ></el-input>
          </el-form-item>
          <el-form-item label-width="120px" label="数量：" prop="nums">
            <el-input
              min="0"
              type="number"
              style="width: 207px; float: left"
              v-model.number="industryItem.nums"
              οninput="value=value.replace(/[^0-9]/g,'')"
            ></el-input>
            <i
              v-if="industryIndex != 0"
              @click="delIndustryType(industryIndex)"
              style="margin-left: 15px; font-size: 20px"
              class="el-icon-delete"
            ></i>
          </el-form-item>
        </el-form>
        <el-button size="small" type="primary" @click="addIndustry()"
          >添加</el-button
        >
        <el-form style="margin-top: 20px">
          <el-form-item>
            <el-button type="primary" @click="industryEdit()">保存</el-button>
            <el-button @click="getIndustryList()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  wcJYInvestEdit,
  wcJYInvestDetail,
  wcJYTargetEdit,
  wcJYTargetDetail,
  wcJYRevenueEdit,
  wcJYRevenueDetail,
  wcJYTaxDetail,
  wcJYTaxEdit,
  wcJYIndustryEdit,
  wcJYIndustryDetail,
} from "@/api/wuchang";
export default {
  components: {},
  computed: {
    ...mapGetters(["imageOss"]),
  },
  data() {
    return {
      loading: false, //是显示加载
      activeName: "invest",
      rules: {
        year_month: [
          { required: true, message: "请输入月份", trigger: "blur" },
        ],
        nums: [{ required: true, message: "请输入数量", trigger: "blur" }],
        park_settlements: [
          {
            required: true,
            message: "请输入园区入驻数量",
            trigger: "blur",
          },
        ],
        park_vacant_area: [
          {
            required: true,
            message: "请输入园区空置面积",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "请输入类型名称",
            trigger: "blur",
          },
        ],
        proportion: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
        introduced_projects: [
          { required: true, message: "请输入引进项目数量", trigger: "blur" },
        ],
        completion_rate: [
          { required: true, message: "请输入招商完成率", trigger: "blur" },
        ],
        settlement_rate: [
          { required: true, message: "请输招商入驻率", trigger: "blur" },
        ],
        converted: [
          { required: true, message: "请输入已转化", trigger: "blur" },
        ],
        to_be_converted: [
          { required: true, message: "请输入待转化", trigger: "blur" },
        ],
        year: [{ required: true, message: "请输入年份", trigger: "blur" }],
        type_name:[{ required: true, message: "请输入类型名称", trigger: "blur" }],
      },
      // 招商
      investForm: {
        introduced_projects: "",
        completion_rate: "",
        settlement_rate: "",
        building_area: "",
        building_finish_area: "",
        building_sale_area: "",
        building_sale_finish_area: "",
      },
      // 园区营收年度目标
      targetForm: {
        target: "",
        finish_rate: "",
        month_finish: "",
      },
      // 园区营收占比概括
      revenueForm: [],
       // 园区税收统计
      taxForm: [{
          year:'',
          quarter:'',
          data:[{
            month:'',
            nums:'',
            month_text:""
          }]
        }],
      // 商业产业类型概括
      industryForm: [],
    };
  },
  mounted() {
    this.getInvestList();
  },
  methods: {
    // 添加年份
    addTax(){
      this.taxForm.push(
        {
          year:'',
          quarter:'',
          data:[{
            month:'',
            nums:'',
            month_text:""
          }]
        }
      )
    },
    // 添加月份
    addData(index){
      this.taxForm[index].data.push({
        month:'',
        nums:'',
        month_text:''
      })
    },
    delTaxData(taxIndex,dataIndex){
      this.taxForm[taxIndex].data.splice(dataIndex, 1);
    },
    // 园区税收统计  编辑
    taxEdit(){
      let data ={
        park_tax_statistics:JSON.stringify(this.taxForm)
      }
      wcJYTaxEdit(data).then(res=>{
        if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            that.getTaxList();
          }
      })
    },
    // 园区税收统计
    getTaxList() {
      wcJYTaxDetail().then((res) => {
        if(res.data){
          this.taxForm = res.data;
        }
      });
    },





    // 商业产业类型概括添加
    addIndustry() {
      this.industryForm.push({
        type_name: "",
        nums: "",
      });
    },
    // 删除商业产业类型概括
    delIndustryType(index) {
      this.industryForm.splice(index, 1);
    },
    // 商业产业类型概括编辑
    industryEdit() {
      var that = this;
      //用Promise.all进行全部form表单的验证
      Promise.all([
        // 招商引进月度工作
        ...this.industryForm.map((item, index) =>
          this.validateForm(`industryForm${index}`)
        ),
      ]).then((res) => {
        let data = {
          park_types: JSON.stringify(this.industryForm),
        };
        wcJYIndustryEdit(data).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            that.getIndustryList();
          }
        });
        if (res) {
          // 全部表单验证通过
        }
      });
    },
    // 商业产业类型概括
    getIndustryList() {
      wcJYIndustryDetail().then((res) => {
        this.industryForm = res.data;
      });
    },

    // 园区税收统计
    addRevenue() {
      this.revenueForm.push({
        type: "",
        proportion: "",
      });
    },
    // 删除园区营收占比概括
    delRevenueType(index) {
      this.revenueForm.splice(index, 1);
    },
    // 园区营收占比概括编辑
    revenueEdit() {
      var that = this;
      //用Promise.all进行全部form表单的验证
      Promise.all([
        //非数组部分的表单
        this.validateForm("refForm"),
        // 招商引进月度工作
        ...this.revenueForm.map((item, index) =>
          this.validateForm(`refForm${index}`)
        ),
      ]).then((res) => {
        let num = 0;
        this.revenueForm.forEach((item) => {
          num = num + Number(item.proportion);
        });
        if (num != 100) {
          this.$message({
            message: "占比不等于100%",
            type: "warning",
          });
          return;
        }
        let data = {
          park_revenue_statistics: JSON.stringify(this.revenueForm),
        };
        wcJYRevenueEdit(data).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            that.getRevenueList();
          }
        });
        if (res) {
          // 全部表单验证通过
        }
      });
    },
    // 园区营收占比概括
    getRevenueList() {
      wcJYRevenueDetail().then((res) => {
        this.revenueForm = res.data;
      });
    },

    // 园区营收年度目标编辑
    targetEdit() {
      var that = this;
      let data = {
        revenue_target: JSON.stringify(this.targetForm),
      };
      wcJYTargetEdit(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          that.getInvestList();
        }
      });
    },
    // 园区营收年度目标
    getTargetList() {
      wcJYTargetDetail().then((res) => {
        this.targetForm = {
          target: res.data.target,
          finish_rate: res.data.finish_rate,
          month_finish: res.data.month_finish,
        };
      });
    },
    // 招商编辑
    investEdit() {
      var that = this;
      let data = {
        promotion_overview: JSON.stringify(this.investForm),
      };
      wcJYInvestEdit(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          that.getInvestList();
        }
      });
    },
    // 招商
    getInvestList() {
      wcJYInvestDetail().then((res) => {
        this.investForm = {
          introduced_projects: res.data.introduced_projects,
          completion_rate: res.data.completion_rate,
          settlement_rate: res.data.settlement_rate,
          building_area: res.data.building_area,
          building_finish_area: res.data.building_finish_area,
          building_sale_area: res.data.building_sale_area,
          building_sale_finish_area: res.data.building_sale_finish_area,
        };
      });
    },
    convertedIup(e) {
      this.formData.to_be_converted = 100 - e.target.value;
    },
    beConvertedIup(e) {
      this.formData.converted = 100 - e.target.value;
    },
    infoSubmit() {
      var that = this;
      //用Promise.all进行全部form表单的验证
      Promise.all([
        //非数组部分的表单
        this.validateForm("refForm"),
        // 数组部分的表单，用map返回验证函数的调用

        // 招商引进月度工作
        ...this.formData.monthly_investment.map((item, index) =>
          this.validateForm(`monthlyForm${index}`)
        ),
        // 园区税收统计
        ...this.formData.park_tax_statistics.map((item, index) =>
          this.validateForm(`parkTaxForm${index}`)
        ),
        // 园区营收统计
        ...this.formData.park_revenue_statistics.map((item, index) =>
          this.validateForm(`parkRevenueForm${index}`)
        ),
        this.$nextTick(() => {
          that.elFormErrorScrollIntoView();
        }),
      ]).then((res) => {
        let overview = {
          introduced_projects: this.formData.introduced_projects,
          completion_rate: this.formData.completion_rate,
          settlement_rate: this.formData.settlement_rate,
        };
        let data = {
          promotion_overview: JSON.stringify(overview),
          investment_conversion_situation: JSON.stringify(situation),
          monthly_investment: JSON.stringify(this.formData.monthly_investment),
          park_tax_statistics: JSON.stringify(
            this.formData.park_tax_statistics
          ),
          park_revenue_statistics: JSON.stringify(
            this.formData.park_revenue_statistics
          ),
        };
        wcJYInvestEdit(data).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            that.getInfo();
          }
        });
        if (res) {
          // 全部表单验证通过
        }
      });
    },
    validateForm(refs) {
      //获取到form表单的dom，如果是对象直接拿到，如果是数组，就拿第一个
      //elementui对循环的form包装成了数组
      let valiForm = this.$refs?.[refs].validate
        ? this.$refs?.[refs]
        : this.$refs?.[refs][0];
      return new Promise((resolve, reject) => {
        //在Promise里进行验证，如果通过就resolve()
        valiForm.validate((res) => {
          if (res) resolve();
          else reject();
        });
      });
    },

    // 添加园区营收统计
    addParkRevenue() {
      this.formData.park_revenue_statistics.push({
        type: "",
        proportion: "",
      });
    },
    // 删除园区营收统计
    delParkRevenue(index) {
      this.formData.park_revenue_statistics.splice(index, 1);
    },
    handleClick(tab, event) {
      if (tab.index == 0) {
        this.getInvestList();
      } else if (tab.index == 1) {
        this.getTargetList();
      } else if (tab.index == 2) {
        this.getRevenueList();
      } else if (tab.index == 3) {
        this.getTaxList();
      } else if (tab.index == 4) {
        this.getIndustryList();
      }
      // if (tab.index == 0) {
      //   this.getEnergyList();
      // } else if (tab.index == 1) {
      //   this.getDutyList();
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;
}
.info {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  padding: 20px;
}

.box-card {
  width: 300px;
  height: 100px;
  display: inline-block;
  margin: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  text-align: center;
  line-height: 100px;
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
.title {
  font-size: 16px;
  font-weight: 600;
}
.formBox {
  width: 100%;
  max-height: 300px;
  overflow: auto;
}

.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
